const TOKEN_KEY = 'token';
const USER_KEY = 'user';
const USER_ROLE_KEY = 'userRole';

import type { User } from '../types/models';

/** 获取 Token */
export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

/** 设置 Token */
export function setToken(token: string): void {
  localStorage.setItem(TOKEN_KEY, token);
}

/** 移除 Token */
export function removeToken(): void {
  localStorage.removeItem(TOKEN_KEY);
}

/** 获取用户信息 */
export function getUser(): User | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as User;
  } catch {
    return null;
  }
}

/** 设置用户信息 */
export function setUser(user: User): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  if (user?.role) {
    localStorage.setItem(USER_ROLE_KEY, user.role);
  }
}

/** 移除用户信息 */
export function removeUser(): void {
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(USER_ROLE_KEY);
}

/** 清除所有认证信息 */
export function clearAuth(): void {
  removeToken();
  removeUser();
}

/** 检查是否已登录 */
export function isAuthenticated(): boolean {
  return !!getToken();
}

/** 获取用户角色 */
export function getUserRole(): string | null {
  return localStorage.getItem(USER_ROLE_KEY);
}
